// eslint-disable-next-line no-unused-vars
import { ILanguage } from './ILanguage';

export default {
  or: 'Ou',
  text: 'volte ao início',
  title: 'clique aqui para cancelar e voltar ao início',
} as ILanguage;
